import { SearchableEntity, Entity, AuditDetails, ActionableEntity, Flag } from '../../entity';
import { ServiceTypeTag, SiteTiny } from '../../shared';
import { Contact, ContactEntity } from '../../contact';
import { EntitySubStatus } from '../../entity.status';
import { SiteProTiny } from './site.pro.tiny';
import { ServiceEntity } from '../../job';
import { EntitySiteBulkAction } from '../../entities';


export interface SitePro extends SiteProTiny, SearchableEntity, ActionableEntity, AuditDetails {

    parent: ContactEntity;
    owner: ContactEntity;
    billTo: ContactEntity;
    contact: ContactEntity;
    manager?: ContactEntity;

    emailCC?: string;
    invoiceTheme?: Entity;

    phone?: string;
    email?: string;
    note?: string;

    // zones: Entity[]; /** Delaying this until the future */
    tags?: Entity[];

    /** scheduling tag */
    schedulingTags?: Entity[];

    /** Return PriceLists for the parent and global */
    defaultSellPriceList?: Entity;
    customFields?: Record<string, any>;
    status?: EntitySubStatus;
    integrationId?: string;

    services: ServiceEntity[];

    processingConfirmationDate?: Date;

    stockLocation?: boolean;
}

export interface SiteProContacts extends SitePro {
    contact1: Contact;
    contact2: Contact;
    contact3: Contact;
}


export function toSite(site: SitePro): SiteTiny {
    return {
        _id: site._id,
        name: site.name,
        address: site.address,
    } as SiteTiny;
}


export enum EntitySiteCommandIds {
    Exists = 'Exists',
    ConfirmServices = 'ConfirmServices',
    RawSite = 'RawSite',
};

export type SiteCommands =
    {
        commandId: EntitySiteCommandIds.Exists,
        data: {
            id: string;
        }
    } |
    {
        commandId: EntitySiteCommandIds.ConfirmServices,
        data: EntitySiteBulkAction
    } |
    {
        commandId: EntitySiteCommandIds.RawSite,
        data: {
            id: string;
        }
    }